import React, { useState, useEffect } from "react";
import axios from "axios";

export const AdminWorkCalendarModelPopup = () => {
  const [weekStart, setWeekStart] = useState("Monday");
  const [weekEnd, setWeekEnd] = useState("Friday");

  const [days, setDays] = useState({
    Sunday: [true, true, true, true, true],
    Monday: [true, true, true, true, true],
    Tuesday: [true, true, true, true, true],
    Wednesday: [true, true, true, true, true],
    Thursday: [true, true, true, true, true],
    Friday: [true, true, true, true, true],
    Saturday: [true, true, true, true, true],
  });

  const [rowChecked, setRowChecked] = useState({
    Sunday: true,
    Monday: true,
    Tuesday: true,
    Wednesday: true,
    Thursday: true,
    Friday: true,
    Saturday: true,
  });

  const apiUrl = process.env.REACT_APP_API_URL;
  const token = localStorage.getItem("token");

  const dayOptions = [
    { value: "Sunday", label: "Sunday" },
    { value: "Monday", label: "Monday" },
    { value: "Tuesday", label: "Tuesday" },
    { value: "Wednesday", label: "Wednesday" },
    { value: "Thursday", label: "Thursday" },
    { value: "Friday", label: "Friday" },
    { value: "Saturday", label: "Saturday" },
  ];

  // Fetch the work calendar from the server when the component mounts
  useEffect(() => {
    const fetchWorkCalendar = async () => {
      try {
        const response = await axios.get(`${apiUrl}/setting/get-work-calendar`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        const { week_start, week_end, off_days } = response.data;

        setWeekStart(week_start);
        setWeekEnd(week_end);

        const updatedDays = {
          Sunday: [true, true, true, true, true],
          Monday: [true, true, true, true, true],
          Tuesday: [true, true, true, true, true],
          Wednesday: [true, true, true, true, true],
          Thursday: [true, true, true, true, true],
          Friday: [true, true, true, true, true],
          Saturday: [true, true, true, true, true],
        };

        Object.keys(off_days).forEach((day) => {
          const weekOffs = off_days[day]; 
          Object.keys(weekOffs).forEach((week) => {
            const weekIndex = parseInt(week[0], 10) - 1; 
            updatedDays[day][weekIndex] = false; // Mark as off day
          });
        });

        setDays(updatedDays);
      } catch (error) {
        console.error("Error fetching work calendar:", error);
      }
    };

    fetchWorkCalendar();
  }, [apiUrl, token]);

  // Save function to save the work calendar changes
  const handleSave = async (event) => {
    event.preventDefault();

    const offDaysPayload = {};

    // Prepare off days based on checked/unchecked states
    Object.keys(days).forEach((day) => {
      const offWeeks = {};
      days[day].forEach((isWorking, index) => {
        if (!isWorking) {  // If unchecked (off day)
          const weekLabel = `${index + 1}st`;
          offWeeks[weekLabel] = "Full";  // Set as full off day
        }
      });
      if (Object.keys(offWeeks).length > 0) {
        offDaysPayload[day] = offWeeks;
      }
    });

    const payload = {
      companyid: 1,
      week_start: weekStart,
      week_end: weekEnd,
      off_days: offDaysPayload,
    };

    try {
      const response = await axios.post(`${apiUrl}/setting/save-work-calendar`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.status === 200) {
        alert("Work calendar settings saved successfully!");
      }
    } catch (error) {
      console.error("Error saving work calendar settings", error);
      alert("Failed to save work calendar settings");
    }
  };

  const handleDayChange = (day, index, value) => {
    const updatedDays = { ...days };
    updatedDays[day][index] = value; // Set the week as checked or unchecked
    setDays(updatedDays);
  };

  const isDayDisabled = (day) => {
    const startIndex = dayOptions.findIndex((opt) => opt.value === weekStart);
    const endIndex = dayOptions.findIndex((opt) => opt.value === weekEnd);
    const currentIndex = dayOptions.findIndex((opt) => opt.value === day);
    return currentIndex < startIndex || currentIndex > endIndex;
  };

  return (
    <>
      <div id="add_work_calendar" className="modal custom-modal fade" role="dialog">
        <div className="modal-dialog modal-lg" style={{ margin: 0, position: "fixed", right: 0, height: "100vh", width: "80%" }} role="document">
          <div className="modal-content h-100">
            <form onSubmit={handleSave} className="d-flex flex-column h-100">
              <div className="modal-header">
                <h5 className="modal-title">Work Calendar Settings</h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>

              <div className="modal-body" style={{ maxHeight: "calc(100vh - 80px)", overflowY: "auto" }}>
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <div className="d-flex flex-column">
                    <label className="col-form-label">Work Week Starts On</label>
                    <select
                      className="form-select"
                      value={weekStart}
                      onChange={(e) => setWeekStart(e.target.value)}
                    >
                      {dayOptions.map((option) => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="d-flex flex-column">
                    <label className="col-form-label">Work Week Ends On</label>
                    <select
                      className="form-select"
                      value={weekEnd}
                      onChange={(e) => setWeekEnd(e.target.value)}
                    >
                      {dayOptions.map((option) => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="table-responsive">
                  <table className="table table-bordered text-center">
                    <thead>
                      <tr>
                        <th>Day</th>
                        <th>All</th>
                        <th>1st Week</th>
                        <th>2nd Week</th>
                        <th>3rd Week</th>
                        <th>4th Week</th>
                        <th>5th Week</th>
                      </tr>
                    </thead>

                    <tbody>
                      {dayOptions.map((option) => (
                        <tr key={option.value}>
                          <td>{option.label}</td>
                          <td>
                            <input
                              className="fancy-checkbox"
                              type="checkbox"
                              checked={rowChecked[option.value]}
                              onChange={() =>
                                setRowChecked((prev) => ({
                                  ...prev,
                                  [option.value]: !prev[option.value],
                                }))
                              }
                              disabled={isDayDisabled(option.value)}
                            />
                          </td>
                          {days[option.value].map((checked, weekIndex) => (
                            <td key={weekIndex}>
                              <input
                                className="fancy-checkbox"
                                type="checkbox"
                                checked={checked}
                                onChange={() =>
                                  handleDayChange(option.value, weekIndex, !checked)
                                }
                                disabled={isDayDisabled(option.value)}
                              />
                            </td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
                  Close
                </button>
                <button className="btn btn-primary submit-btn" type="submit">
                  Save Settings
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default AdminWorkCalendarModelPopup;
